
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCompanyInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginEtsUsername"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginEtsPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginSsaPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginSsaUsername"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"loginEtsUsername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginEtsUsername"}}},{"kind":"Argument","name":{"kind":"Name","value":"loginEtsPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginEtsPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"loginSsaPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginSsaPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"loginSsaUsername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginSsaUsername"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"terminalLoginEtsUsername"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"terminalLoginEtsPassword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"terminalLoginSsaPassword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"terminalLoginSsaUsername"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":536}};
    doc.loc.source = {"body":"mutation updateCompanyInfo($companyAddress: String, $loginEtsUsername: String, $loginEtsPassword: String, $loginSsaPassword: String, $loginSsaUsername: String) {\n  updateCompanyInfo(companyAddress: $companyAddress, loginEtsUsername: $loginEtsUsername, loginEtsPassword:$loginEtsPassword, loginSsaPassword: $loginSsaPassword, loginSsaUsername:$loginSsaUsername) {\n    company {\n      id\n      address\n      terminalLoginEtsUsername\n      terminalLoginEtsPassword\n      terminalLoginSsaPassword\n      terminalLoginSsaUsername\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["updateCompanyInfo"] = oneQuery(doc, "updateCompanyInfo");
        
